import { useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import InnovaImg from "../assets/wallpapers/Innova_V2.jpg";
import "./BookNow.css";

export default function BookNow() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    contact: "",
    pickup: "",
    drop: "",
    date: "",
    vehicle: "Dzire",
    travelOption: "Outstation Travel",
    email: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending booking...");

    try {
      // Send to admin
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN,
        { ...formData, to_email: process.env.REACT_APP_ADMIN_EMAIL },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      // Send confirmation to customer
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CUSTOMER,
        { ...formData, to_email: formData.email },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setStatus("Booking successful!");
      setTimeout(() => navigate("/thank-you"), 1000);
    } catch (error) {
      console.error(error);
      setStatus("Failed to send booking. Please try again.");
    }
  };

  return (
    <div
      className="book-now-container"
      style={{
        backgroundImage: `url(${InnovaImg})`,
      }}
    >
      <form className="transparent-form" onSubmit={handleSubmit}>
        <h2>Book Now</h2>

        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          autoComplete="off"
          required
        />
        <input
          type="tel"
          name="contact"
          placeholder="Contact Number"
          value={formData.contact}
          onChange={handleChange}
          autoComplete="off"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          autoComplete="off"
          required
        />
        <input
          type="text"
          name="pickup"
          placeholder="Pickup Location"
          value={formData.pickup}
          onChange={handleChange}
          autoComplete="off"
          required
        />
        <input
          type="text"
          name="drop"
          placeholder="Drop Location"
          value={formData.drop}
          onChange={handleChange}
          autoComplete="off"
          required
        />
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <select name="vehicle" value={formData.vehicle} onChange={handleChange}>
          <option value="Dzire">Dzire</option>
          <option value="Ertiga">Ertiga</option>
          <option value="Innova">Innova</option>
        </select>
        <select
          name="travelOption"
          value={formData.travelOption}
          onChange={handleChange}
        >
          <option value="Outstation Travel">Outstation Travel</option>
          <option value="Local Travel">Local Travel</option>
        </select>

        <button type="submit">Submit</button>
        {status && <p className="status-msg">{status}</p>}
      </form>
    </div>
  );
}
